<template>
  <footer
    class="footer"
    :class="{ [`footer-${type}`]: type }"
    :data-background-color="backgroundColor"
  >
    <div class="container">
      <nav>
        <img v-lazy="'/img/logo.png'" height="60px" />
      </nav>
      <div class="copyright">
        <a href="mailto://info@nplusent.com">
              Contact : info@nplusent.com
        </a>
        <br/>
        &copy; {{ year }}, NPLUS ENTERTAINMENT PTE. LTD
        <br>
        <a href="//docs.google.com/document/d/1qWC4AO6xt8doM3EI3MROQWcwcX_k7qaEzPHitSFcuZA/edit?usp=sharing" style="margin: 5px;" target="_blank">Privacy Policy</a><a href="//docs.google.com/document/d/1OCUgA-HX8fs-kRebtNvTD1wDvi-broe10adSVWm6to4/edit?usp=sharing" style="margin: 5px;" target="_blank">Terms of use</a>
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  props: {
    backgroundColor: String,
    type: String
  },
  data() {
    return {
      year: new Date().getFullYear()
    };
  }
};
</script>
<style></style>
